<div class="max-w-[90vw] min-w-[60vw]">

    
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
        <div class="text-lg font-medium">{{getModalTitle()}}</div>
        <button
            mat-icon-button
            (click)="close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Main -->
    <div class="mt-12 max-h-[calc(100vh-170px)] overflow-y-scroll px-1">
        <mat-horizontal-stepper [linear]="true" labelPosition="bottom" #stepper (selectionChange)="onStepChange($event)">

            <!-- Overview Step -->
            <mat-step *ngIf="isClosedForEditing" label="Overview">
                <div class="flex flex-col gap-6">
                    <!-- Details -->
                    <div class="border rounded-2xl p-5 grid grid-cols-2 gap-4 w-full bg-[#f8f8f8]">
                        <!-- <div class="text-xl col-span-2">Details</div> -->

                        <div class="flex flex-col">
                            <div class="uppercase text-md">PO Number</div>
                            <div class="text-lg">{{purchaseOrder?.salesOrderRef}}</div>
                        </div>
                        <div class="flex flex-col">
                            <div class="uppercase text-md">Status</div>
                            <div class="mt-1" [style]="getStatusStyle(purchaseOrder?.status)">{{getStatusText(purchaseOrder?.status)}}</div>
                        </div>
                        <div class="flex flex-col">
                            <div class="uppercase text-md">{{isSupplier ? 'Supplier' : 'Company'}}</div>
                            <div class="text-lg">{{isSupplier ? purchaseOrder?.supplier : purchaseOrder.company}}</div>
                        </div>
                        <div class="flex flex-col">
                            <div class="uppercase text-md">Total Value</div>
                            <div class="text-lg text-green-500">{{getGrandTotal() | currency:'GBP'}}</div>
                        </div>
                    </div>
                    
                    <div class="text-xl col-span-2">Order Details</div>
                    <div class="border rounded-2xl p-5 grid grid-cols-2 gap-4 w-full bg-[#f8f8f8] -mt-4">
                        <div class="flex flex-col">
                            <div class="uppercase text-md">Order Date</div>
                            <div class="text-lg">{{purchaseOrder?.date | date:'dd/MM/yyyy'}}</div>
                        </div>
                        <div class="flex flex-col">
                            <div class="uppercase text-md">Expected Delivery</div>
                            <div class="text-lg">{{getFurthestDeliveryDate()}}</div>
                        </div>
                        <div class="flex flex-col">
                            <div class="uppercase text-md">Items Count</div>
                            <div class="text-lg">{{purchaseOrder?.itemCount}} item{{purchaseOrder?.itemCount == 1 ? '' : 's'}}</div>
                        </div>
                        <div class="flex flex-col">
                            <div class="uppercase text-md">Job Reference</div>
                            <div class="text-lg text-primary">{{purchaseOrder?.salesOrderRef2 || '-'}}</div>
                        </div>
                    </div>

                    <!-- Approval Audit Trail -->
                    <ng-container *ngIf="purchaseOrder?.approvedByName">
                        <div class="text-xl col-span-2">Approval</div>
                        <div class="border rounded-2xl p-5 grid grid-cols-2 gap-4 w-full bg-[#f8f8f8] -mt-4">
                            <div class="flex flex-col">
                                <div class="uppercase text-md">Approved By</div>
                                <div class="text-lg">{{purchaseOrder.approvedByName}}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="uppercase text-md">Approval Date</div>
                                <div class="text-lg">{{purchaseOrder.approvalDate | date:'dd/MM/yyyy, h:mm a'}}</div>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Linked PO/SOs -->
                    <ng-container *ngIf="linkedPos?.length">
                        <div class="text-xl col-span-2">Related {{isProduct ? 'Purchase' : isSupplier ? 'Sales' : 'Purchase'}} Order{{linkedPos?.length > 1 ? 's' : ''}}</div>
                        <div class="border rounded-2xl p-5 w-full bg-[#f8f8f8] -mt-4 flex flex-col gap-4">
                            <ng-container *ngFor="let po of linkedPos">
                                <div class="bg-white border rounded-lg py-3 px-4 flex gap-4 items-center hover:bg-gray-50 cursor-pointer transition-colors" (click)="openLinkedPo(po.purchaseOrderId)">
                                    <mat-icon class="text-primary" [svgIcon]="'mat_outline:shopping_cart'"></mat-icon>
                                    <div>
                                        <div class="text-primary">{{po.salesOrderRef}}</div>
                                        <div class="text-md">{{po.title}}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>

                    
                    <!-- Actions -->
                    <div class="col-span-4 flex items-center justify-between gap-4 pt-6 border-t">
                        <button
                            class="mr-auto"
                            (click)="navigateToPurchaseOrderList()"
                            mat-stroked-button
                            type="button">
                            Close
                        </button>

                        <button
                            *ngIf="purchaseOrder?.status == PurchaseOrderStatus.PendingApproval"
                            mat-flat-button
                            class="bg-red-500"
                            type="button"
                            [color]="'primary'"
                            (click)="approvePo(false)"
                            [disabled]="!hasWriteAccess">
                            Reject {{isSalesOrder() ? 'SO' : isPurchaseOrder() ? 'PO' : 'Hire'}}
                        </button>

                        <button
                            *ngIf="purchaseOrder?.status == PurchaseOrderStatus.PendingApproval"
                            mat-flat-button
                            class="bg-green-500"
                            type="button"
                            [color]="'primary'"
                            (click)="approvePo()"
                            [disabled]="!hasWriteAccess">
                            Approve {{isSalesOrder() ? 'SO' : isPurchaseOrder() ? 'PO' : 'Hire'}}
                        </button>

                        <button
                            *ngIf="purchaseOrder?.status == PurchaseOrderStatus.AwaitingCustomerApproval"
                            mat-flat-button
                            class="bg-green-500"
                            type="button"
                            [color]="'primary'"
                            (click)="approveCustomerApproval()"
                            [disabled]="!hasWriteAccess">
                            Customer Approved
                        </button>

                        <mat-form-field
                            *ngIf="purchaseOrder?.status != PurchaseOrderStatus.PendingApproval && purchaseOrder?.status != PurchaseOrderStatus.AwaitingCustomerApproval"
                            class="fuse-mat-dense fuse-mat-rounded min-w-48 mr-auto" 
                            [subscriptSizing]="'dynamic'"
                            >
                            <mat-select [disabled]="!hasWriteAccess" class="fuse-mat-dense" [subscriptSizing]="'dynamic'" [value]="purchaseOrder?.status" (selectionChange)="updateStatus($event)">
                                <mat-select-trigger [style]="'color: ' + getStatusColour(purchaseOrder?.status)">{{getStatusText(purchaseOrder?.status)}}</mat-select-trigger>
                                <ng-container *ngFor="let status of getAllowedStatuses(); trackBy: trackByFn">
                                    <mat-option [value]="status.value">
                                        <div [style]="getStatusStyle(status.value)">{{status.name}}</div>
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        

                        <button
                            *ngIf="isSupplier && (
                                purchaseOrder?.status == PurchaseOrderStatus.Ordered ||
                                purchaseOrder?.status == PurchaseOrderStatus.Dispatched ||
                                purchaseOrder?.status == PurchaseOrderStatus.PartialReceived ||
                                purchaseOrder?.status == PurchaseOrderStatus.Received
                            )"
                            mat-flat-button
                            [color]="'primary'"
                            (click)="generateGoodsIn()"
                            [disabled]="!hasWriteAccess">
                            <span class="ml-2 mr-1">
                                {{purchaseOrder?.status == PurchaseOrderStatus.Ordered || purchaseOrder?.status == PurchaseOrderStatus.Dispatched ? 'Receive and' : ''}}
                                {{grnId ? 'Open' : 'Generate'}} GRN
                            </span>
                        </button>

                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'">
                            Next
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- Payments Step -->
            <mat-step *ngIf="!canSaveAsDraft && !isPurchaseOrder()" label="Payments">
                <form *ngIf="paymentFormGroup" [formGroup]="paymentFormGroup">

                    <div class="border rounded-2xl p-5 flex flex-col gap-6 w-full bg-[#f8f8f8]">
                        <div class="text-xl">Payments</div>

                        <!-- PurchaseOrder Payments table -->
                        <div class="scrollable-list flex flex-col">
                            <ng-container *ngIf="paymentItems?.controls">
                                <ng-container *ngIf="paymentItems?.controls.length > 0; else noPayments">
                                    <div class="grid">
                                        <!-- Header -->
                                        <div class="z-10 sticky top-0 grid grid-cols-11 gap-4 pb-4 text-secondary border-b">
                                            <div class="col-span-5 elipsis">Amount</div>
                                            <div class="col-span-5 elipsis">Date</div>
                                            <div class="col-span-1 elipsis"></div>
                                        </div>
                                        <!-- Rows -->
                                        <ng-container *ngIf="paymentItems?.controls" formArrayName="paymentItems" >
                                            <ng-container *ngFor="let itemControl of paymentItems?.controls; let i = index" [formGroupName]="i">
                                                <div class="project-row grid grid-cols-11 gap-4 items-center py-3">
                                                    <mat-form-field class="sm:col-span-5 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <input matInput
                                                        [disabled]="!hasWriteAccess"
                                                        [value]="itemControl?.get('amount')?.value ?? 0 | currency: '£'"
                                                        (blur)="updateCurrency($event, itemControl, 'amount')">
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-5 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <input
                                                            [formControlName]="'date'"
                                                            [matDatepicker]="date"
                                                            matInput>
                                                        <mat-datepicker-toggle matIconSuffix [for]="date"></mat-datepicker-toggle>
                                                        <mat-datepicker #date></mat-datepicker>
                                                    </mat-form-field>

                                                    <div class="col-span-1 flex justify-end">
                                                        <button
                                                            mat-icon-button
                                                            (click)="deletePaymentItem(i)"
                                                            [matTooltip]="'Delete'"
                                                            [disabled]="!hasWriteAccess">
                                                            <mat-icon
                                                                [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-template #noPayments>
                                <div class="p-8 sm:p-16 border-t text-4xl  tracking-tight text-center">
                                    {{ "There are no payments yet" }}
                                </div>
                            </ng-template>
                        </div>
                        <div class="flex items-center justify-start">
                            <button
                                color="primary"
                                class="mt-2"
                                mat-flat-button
                                type="button"
                                [disabled]="!hasWriteAccess"
                                (click)="addPurchaseOrderPayment()">
                                Add Item
                            </button>
                        </div>

                        <!-- Divider -->
                        <div class="col-span-4 my-6 border-t"></div>

                        <!-- Totals -->
                        <div>
                            <div class="flex flex-row justify-end">
                                <p>Amount:</p>
                                <p class="total-value text-right">{{getGrandTotal() | currency: '£'}}</p>
                            </div>
                            <div class="flex flex-row justify-end">
                                <p>Paid:</p>
                                <p class="total-value text-right">{{"-" + getPaymentTotal() | currency: '£'}}</p>
                            </div>                            
                            <div class="flex flex-row justify-end">
                                <p>Remaining:</p>
                                <p class="total-value text-right">{{(getGrandTotal() - getPaymentTotal()) | currency: '£'}}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="col-span-4 flex items-center justify-between gap-4 pt-6 mt-6 border-t">
                        <button
                            *ngIf="!isClosedForEditing"
                            class="mr-auto"
                            (click)="navigateToPurchaseOrderList()"
                            mat-stroked-button
                            type="button">
                            Close
                        </button>

                        <button
                            *ngIf="isClosedForEditing"
                            class="mr-auto"
                            matStepperPrevious
                            mat-stroked-button
                            type="button">
                            Back
                        </button>

                        <button
                            mat-stroked-button
                            (click)="save()"
                            [disabled]="paymentFormGroup?.invalid || !hasWriteAccess">
                            <span class="ml-2 mr-1">Save</span>
                        </button>

                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'"
                            [disabled]="paymentFormGroup?.invalid">
                            Next                
                        </button>
                    </div>
                </form>
            </mat-step>

            <!-- Step 1 -->
            <mat-step *ngIf="!isClosedForEditing" [stepControl]="firstFormGroup" label="Basic Details">
                <form *ngIf="firstFormGroup" [formGroup]="firstFormGroup">

                    <div class="border rounded-2xl p-5 grid grid-cols-4 gap-6 w-full bg-[#f8f8f8]">
                        <div class="text-xl col-span-4">Details</div>

                        <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>{{isProduct ? 'SO' : isSupplier ? 'PO' : 'SO'}} Number</mat-label>
                            <input matInput
                                formControlName="salesOrderRef">
                        </mat-form-field>

                        <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Linked {{isProduct ? 'PO' : isSupplier ? 'SO' : 'PO'}} Reference</mat-label>
                            <input matInput [placeholder]="isProduct ? 'PO' : isSupplier ? 'SO Number' : 'PO Number'"
                                formControlName="salesOrderRef2" [disabled]="isDispatched()">
                        </mat-form-field>


                        <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'" [class.col-span-4]="!isProduct" [class.col-span-2]="isProduct">
                            <mat-label>{{isProduct ? 'Sales' : isSupplier ? 'Purchase' : 'Hire'}} Order Title</mat-label>
                            <input matInput placeholder="Please supply a title"
                                formControlName="title" required [disabled]="isDispatched()">
                            <mat-error *ngIf="firstFormGroup?.controls['title'].hasError('required')">
                                Please enter a title
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field *ngIf="isProduct" class="col-span-2 fuse-mat-dense">
                            <mat-label>Category</mat-label>
                            <mat-select [formControlName]="'dealCategory'" [subscriptSizing]="'dynamic'">
                                <ng-container *ngFor="let cat of categories">
                                    <mat-option [value]="cat.value">
                                        <div>{{cat.name}}</div>
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-span-4 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Summary (Max 100 Characters)</mat-label>
                            <input matInput [placeholder]="'Please supply a description of your ' + (isProduct ? 'Sales' : isSupplier ? 'Purchase' : 'Hire') + ' Order to assist identification'"
                                formControlName="summary" maxlength="100" [disabled]="isDispatched()">
                            <mat-error *ngIf="firstFormGroup?.controls['summary'].hasError('required')">
                                Please enter a summary
                            </mat-error>
                        </mat-form-field>

                        <ng-container *ngIf="isHireOrder() || isSalesOrder()">
                            <mat-form-field
                                class="col-span-2 fuse-mat-dense"
                                [subscriptSizing]="'dynamic'">
                                <mat-label>Client</mat-label>
                                <mat-select
                                    [formControlName]="'company'"
                                    [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                    disableOptionCentering
                                    #clientSelect="matSelect"
                                    (selectionChange)="updateClient($event)">
                                    <ng-container *ngFor="let client of companies">
                                        <mat-option
                                            class="h-auto py-4 leading-none"
                                            [value]="client.name"
                                            [disabled]="isDispatched()">
                                            <div class="font-medium">{{client.name}}</div>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup?.controls['company'].hasError('required')">
                                    Please select a client
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field
                                class="inline col-span-2 fuse-mat-dense"
                                [subscriptSizing]="'dynamic'">
                                <mat-label>Contact</mat-label>
                                <mat-select
                                    [formControlName]="'contact'"
                                    [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                    disableOptionCentering
                                    #contactSelect="matSelect"
                                    (selectionChange)="updateContact($event)">
                                    <ng-container *ngFor="let contact of company?.additionalContacts">
                                        <mat-option
                                            class="h-auto py-4 leading-none"
                                            [value]="contact?.id"
                                            [disabled]="isDispatched()">
                                            <div class="font-medium">{{contact.name}}</div>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup?.controls['contact'].hasError('required')">
                                    Please select a contact
                                </mat-error>
                            </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="isPurchaseOrder()">
                            <mat-form-field
                                class="col-span-2 fuse-mat-dense"
                                [subscriptSizing]="'dynamic'">
                                <mat-label>Supplier</mat-label>
                                <mat-select
                                    [formControlName]="'company'"
                                    [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                    disableOptionCentering
                                    #supplierSelect="matSelect"
                                    (selectionChange)="updateSupplier($event)">
                                    <ng-container *ngFor="let supplier of suppliers">
                                        <mat-option
                                            class="h-auto py-4 leading-none"
                                            [value]="supplier.name"
                                            [disabled]="isDispatched()">
                                            <div class="font-medium">{{supplier.name}}</div>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup?.controls['company'].hasError('required')">
                                    Please select a supplier
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field
                                class="inline col-span-2 fuse-mat-dense"
                                [subscriptSizing]="'dynamic'">
                                <mat-label>Contact</mat-label>
                                <mat-select
                                    [formControlName]="'contact'"
                                    [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                    disableOptionCentering
                                    #contactSelect="matSelect"
                                    (selectionChange)="updateSupplierContact($event)">
                                    <ng-container *ngFor="let contact of supplier?.contacts">
                                        <mat-option
                                            class="h-auto py-4 leading-none"
                                            [value]="contact?.supplierContactId"
                                            [disabled]="isDispatched()">
                                            <div class="font-medium">{{contact.name}}</div>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup?.controls['contact'].hasError('required')">
                                    Please select a contact
                                </mat-error>
                            </mat-form-field>
                        </ng-container>
                    </div>

                    <!-- Actions -->
                    <div class="col-span-4 flex items-center justify-between gap-4 pt-6 mt-6 border-t">
                        <button
                            *ngIf="canSaveAsDraft || isPurchaseOrder()"
                            class="mr-auto"
                            (click)="navigateToPurchaseOrderList()"
                            mat-stroked-button
                            type="button">
                            Close
                        </button>

                        <button
                            *ngIf="!canSaveAsDraft && !isPurchaseOrder()"
                            class="mr-auto"
                            matStepperPrevious
                            mat-stroked-button
                            type="button">
                            Back
                        </button>

                        <button
                            *ngIf="!canSaveAsDraft"
                            mat-stroked-button
                            (click)="save()"
                            [disabled]="firstFormGroup?.invalid || !hasWriteAccess">
                            <span class="ml-2 mr-1">Save</span>
                        </button>
                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'"
                            [disabled]="firstFormGroup?.invalid">
                            Next                
                        </button>
                    </div>
                </form>
            </mat-step>

            <!-- Step 2 -->
            <mat-step *ngIf="!isClosedForEditing" [stepControl]="secondFormGroup" label="Delivery & Contact">
                <form *ngIf="secondFormGroup" [formGroup]="secondFormGroup">

                    <div class="border rounded-2xl p-5 grid grid-cols-4 gap-6 w-full bg-[#f8f8f8]">
                        <div class="text-xl col-span-4">{{isProduct ? 'Client Delivery' : isSupplier ? 'Delivery' : 'Client Delivery'}} Address</div>

                        <mat-form-field *ngIf="isHireOrder() || isSalesOrder()" class="col-span-4 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Address</mat-label>
                            <mat-select
                                [formControlName]="'address1'"
                                disableOptionCentering>
                                
                                <ng-container *ngIf="company?.customerLocations?.length > 0; else noAddresses">
                                    <ng-container *ngFor="let address of company.customerLocations">
                                        <mat-option
                                            class="h-auto leading-none"
                                            [value]="address.location"
                                            [disabled]="isDispatched()">
                                            <div class="font-medium">{{ address.location }}</div>
                                        </mat-option>
                                    </ng-container>
                                </ng-container>

                                <ng-template #noAddresses>
                                    <mat-option
                                        class="h-auto leading-none"
                                        [value]="null"
                                        disabled>
                                        <div class="font-medium">There are no addresses saved for this client</div>
                                    </mat-option>
                                </ng-template>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-span-4 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Address Line 1</mat-label>
                            <input matInput placeholder="Address Line 1"
                                formControlName="address1" [readonly]="isDispatched()">
                        </mat-form-field>
                        
                        <ng-container *ngIf="isPurchaseOrder()">
                            <mat-form-field class="col-span-4 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Address Line 2</mat-label>
                                <input matInput placeholder="Address Line 2"
                                    formControlName="address2" [readonly]="isDispatched()">
                            </mat-form-field>

                            <mat-form-field class="col-span-4 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>City / Town</mat-label>
                                <input matInput placeholder="e.g. Manchester"
                                    formControlName="city" [readonly]="isDispatched()">
                            </mat-form-field>

                            <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>County</mat-label>
                                <input matInput placeholder="e.g. Greater Manchester"
                                    formControlName="county" [readonly]="isDispatched()">
                            </mat-form-field>

                            <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Post Code</mat-label>
                                <input matInput placeholder="e.g. EC2 2AG"
                                    formControlName="postcode" [readonly]="isDispatched()">
                            </mat-form-field>
                        </ng-container>
                    </div>

                    <!-- Actions -->
                    <div class="col-span-4 flex items-center justify-between gap-4 pt-6 mt-6 border-t">
                        <button
                            class="mr-auto"
                            matStepperPrevious
                            mat-stroked-button
                            type="button">
                            Back
                        </button>

                        <button
                            *ngIf="!canSaveAsDraft"
                            mat-stroked-button
                            (click)="save()"
                            [disabled]="secondFormGroup?.invalid || !hasWriteAccess">
                            <span class="ml-2 mr-1">Save</span>
                        </button>

                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'"
                            [disabled]="secondFormGroup?.invalid">
                            Next                
                        </button>
                    </div>
                </form>
            </mat-step>

            <!-- Step 3 -->
            <mat-step *ngIf="!isClosedForEditing" [stepControl]="thirdFormGroup" label="Line Items">
                <form *ngIf="thirdFormGroup" [formGroup]="thirdFormGroup" class="flex flex-col gap-6">

                    <div class="border rounded-2xl p-5 flex flex-col gap-6 w-full bg-[#f8f8f8]">
                        <div class="text-xl">Line Items</div>

                        <!-- PurchaseOrder Items table -->
                        <div class="scrollable-list flex flex-col gap-6">
                            <ng-container *ngIf="hireItems?.controls && partItems?.controls">
                                <ng-container *ngIf="(isHireOrder() && hasAssets()) || (isPurchaseOrder() && hasParts()) || (isSalesOrder() && hasProducts()); else noItems">
                                    
                                    <!-- Rows - Assets -->
                                    <ng-container *ngIf="hireItems?.controls" formArrayName="hireItems">
                                        <ng-container *ngFor="let itemControl of hireItems?.controls; let i = index" [formGroupName]="i">
                                            <div class="border rounded-xl bg-white flex flex-col gap-4 items-center">

                                                <div class="py-2 px-4 border-b flex gap-4 items-center w-full text-lg justify-between">
                                                    <div>Line: {{i+1}}</div>
                                                    <button *ngIf="!isDispatched()"
                                                        mat-icon-button
                                                        (click)="deleteHireItem(i)"
                                                        [matTooltip]="'Delete'"
                                                        [disabled]="!hasWriteAccess">
                                                        <mat-icon
                                                            [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                    </button>
                                                </div>

                                                <div class="grid sm:grid-cols-13 gap-4 items-center px-4 pb-4 w-full">

                                                    <mat-form-field class="sm:col-span-4 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Part Number</mat-label>
                                                        <input matInput [matAutocomplete]="auto"
                                                            [formControlName]="'description'"
                                                            (input)="filterAssets($event)"
                                                            [readonly]="isDispatched()"
                                                        >
                                                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onHireItemSelected($event, itemControl)" [disabled]="isDispatched()">
                                                            <mat-option *ngFor="let asset of filteredAssets"
                                                                [value]="asset?.name"
                                                                [disabled]="isDispatched()">
                                                                {{ asset?.name }}
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                    </mat-form-field>

                                                    <div class="sm:col-span-1 w-full">
                                                        <mat-label>Standby?</mat-label>
                                                        <mat-checkbox
                                                            matInput
                                                            color="primary"
                                                            [value]="itemControl?.get('isStandby')?.value"
                                                            [checked]="itemControl?.get('isStandby')?.value"
                                                            [formControlName]="'isStandby'"
                                                            (change)="toggleStandby(itemControl, $event)"
                                                            [disabled]="isDispatched()">
                                                        </mat-checkbox>
                                                    </div>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Price/Day *</mat-label>
                                                        <input matInput
                                                            [value]="itemControl?.get('price')?.value ?? 0 | currency: '£'"
                                                            (blur)="updateCurrency($event, itemControl, 'price')"
                                                            [readonly]="isDispatched()">
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-4 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Hire Range</mat-label>
                                                        <mat-date-range-input [rangePicker]="hireRangePicker" [readonly]="isDispatched()">
                                                            <input matStartDate placeholder="Start date" [formControlName]="'hireFrom'" [readonly]="isDispatched()">
                                                            <input matEndDate placeholder="End date" [formControlName]="'hireTo'" [readonly]="isDispatched()">
                                                        </mat-date-range-input>
                                                        <mat-datepicker-toggle matSuffix [for]="hireRangePicker" [disabled]="isDispatched()"></mat-datepicker-toggle>
                                                        <mat-date-range-picker #hireRangePicker [disabled]="isDispatched()"></mat-date-range-picker>
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>VAT</mat-label>
                                                        <mat-select
                                                            [formControlName]="'vat'"
                                                            [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                                            disableOptionCentering
                                                            (selectionChange)="updateVAT($event, itemControl)">
                                                            <ng-container *ngFor="let vat of vatOptions">
                                                                <mat-option
                                                                    class="h-auto py-4 leading-none"
                                                                    [value]="vat.value"
                                                                    [disabled]="isDispatched()">
                                                                    <div class="font-medium">{{vat?.name}}</div>
                                                                </mat-option>
                                                            </ng-container>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>

                                                <div class="p-4 border-t flex gap-4 items-center w-full text-lg">
                                                    <div class="ml-auto">Subtotal: {{getHireItemSubtotal(itemControl) | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <!-- Rows - Parts -->
                                    <ng-container *ngIf="partItems?.controls" formArrayName="partItems">
                                        <ng-container *ngFor="let itemControl of partItems?.controls; let i = index" [formGroupName]="i">

                                            <div class="border rounded-xl bg-white flex flex-col gap-4 items-center"
                                                [class.flag-row]="partIsNonStock(itemControl) || partIsFlagged(itemControl) || partIsOverMaxStock(itemControl)">

                                                <div class="py-2 px-4 border-b flex gap-4 items-center w-full text-lg justify-between">
                                                    <div>Line: {{i+1}}</div>
                                                    <button *ngIf="!isDispatched()"
                                                        mat-icon-button
                                                        (click)="deletePartItem(i)"
                                                        [matTooltip]="'Delete'"
                                                        [disabled]="!hasWriteAccess">
                                                        <mat-icon
                                                            [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                    </button>
                                                </div>

                                                <div class="grid sm:grid-cols-11 gap-4 items-center px-4 pb-4 w-full">
                                                    <mat-form-field class="sm:col-span-3 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Part Number</mat-label>
                                                        <input matInput [matAutocomplete]="autoParts"
                                                            [formControlName]="'description'"
                                                            (input)="filterParts($event)"
                                                            [readonly]="isDispatched()"
                                                        >
                                                        <mat-autocomplete #autoParts="matAutocomplete" (optionSelected)="onPartItemSelected($event, itemControl)" [disabled]="isDispatched()">
                                                            <mat-option *ngFor="let part of filteredParts"
                                                                [value]="part?.number"
                                                                [disabled]="isDispatched()">
                                                                <div class="flex gap-1 items-center">
                                                                    <span>{{part.number}}</span>
                                                                    <mat-icon *ngIf="part.isHighRisk" [matTooltip]="'High Risk'"          color="warn" class="icon-size-4 m-0" svgIcon="mat_solid:warning"></mat-icon>
                                                                    <mat-icon *ngIf="part.isCritical" [matTooltip]="'Critical Component'" color="warn" class="icon-size-4 m-0" svgIcon="mat_solid:flag">
                                                                    <mat-icon *ngIf="part.currentStock < part.minimumStock" [matTooltip]="'Stock under Minimum'" color="warn" class="icon-size-5" svgIcon="mat_solid:remove_shopping_cart"></mat-icon></mat-icon>
                                                                </div>
                                                                <div class="text-sm leading-[1.1] pb-2">{{part.description}}</div>
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>{{isSupplier ? 'Cost' : 'Price'}}/Unit *</mat-label>
                                                        <input matInput
                                                            [value]="itemControl?.get('price')?.value ?? 0 | currency: '£'"
                                                            (blur)="updateCurrency($event, itemControl, 'price')"
                                                            [disabled]="!hasWriteAccess"
                                                            [readonly]="isDispatched()">
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Quantity</mat-label>
                                                        <input type="number" matInput
                                                            [formControlName]="'quantity'"
                                                        >
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>VAT</mat-label>
                                                        <mat-select
                                                            [formControlName]="'vat'"
                                                            [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                                            disableOptionCentering
                                                            (selectionChange)="updateVAT($event, itemControl)">
                                                            <ng-container *ngFor="let vat of vatOptions">
                                                                <mat-option
                                                                    class="h-auto py-4 leading-none"
                                                                    [value]="vat.value"
                                                                    [disabled]="isDispatched()">
                                                                    <div class="font-medium">{{vat?.name}}</div>
                                                                </mat-option>
                                                            </ng-container>
                                                        </mat-select>
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Delivery Date</mat-label>
                                                        <input
                                                            [formControlName]="'requiredDeliveryDate'"
                                                            [matDatepicker]="deliveryDatePicker"
                                                            matInput>
                                                        <mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #deliveryDatePicker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>

                                                <div *ngIf="partIsNonStock(itemControl) || partIsFlagged(itemControl) || partIsOverMaxStock(itemControl)" class="flex self-start gap-4 ml-5 -mt-6 text-md">
                                                    <span *ngIf="partIsNonStock(itemControl)" class="text-red-500">Part is Non-Stock</span>
                                                    <span *ngIf="partIsFlagged(itemControl)" class="text-red-500">Part is Risk Flagged</span>
                                                    <span *ngIf="partIsOverMaxStock(itemControl)" class="text-red-500">Part is over Max Stock ({{getPartMaxStock(itemControl)}})</span>
                                                    <span *ngIf="!isAdmin" class="text-red">- Requires admin permissions to proceed</span>
                                                </div>
                                                
                                                <div class="p-4 border-t flex gap-4 items-center w-full text-lg">
                                                    <div class="ml-auto">Subtotal: {{getPartItemSubtotal(itemControl) | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <!-- Rows - Products -->
                                    <ng-container *ngIf="productItems?.controls" formArrayName="productItems">
                                        <ng-container *ngFor="let itemControl of productItems?.controls; let i = index" [formGroupName]="i">
                                            <div class="border rounded-xl bg-white flex flex-col gap-4 items-center"
                                                [class.flag-row]="countProductShort(itemControl) > 0">

                                                <div class="py-2 px-4 border-b flex gap-4 items-center w-full text-lg justify-between">
                                                    <div>Line: {{i+1}}</div>
                                                    <button *ngIf="!isDispatched()"
                                                        mat-icon-button
                                                        (click)="deleteProductItem(i)"
                                                        [matTooltip]="'Delete'"
                                                        [disabled]="!hasWriteAccess">
                                                        <mat-icon
                                                            [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                    </button>
                                                </div>

                                                <div class="grid sm:grid-cols-13 gap-4 items-center px-4 pb-4 w-full">

                                                    <mat-form-field class="sm:col-span-3 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Part Number</mat-label>
                                                        <input matInput [matAutocomplete]="autoProducts"
                                                            [formControlName]="'description'"
                                                            (input)="filterProducts($event)"
                                                            [readonly]="isDispatched()"
                                                        >
                                                        <mat-autocomplete #autoProducts="matAutocomplete" (optionSelected)="onProductItemSelected($event, itemControl)" [disabled]="isDispatched()">
                                                            <mat-option *ngFor="let product of filteredProducts"
                                                                [value]="product?.partNumber"
                                                                [disabled]="isDispatched()">
                                                                <div>{{product.partNumber}}</div>
                                                                <div class="text-sm leading-[1.1] pb-2">{{product.description}}</div>
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Price/Each *</mat-label>
                                                        <input matInput
                                                            [value]="itemControl?.get('price')?.value ?? 0 | currency: '£'"
                                                            (blur)="updateCurrency($event, itemControl, 'price')"
                                                            [readonly]="isDispatched()">
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Quantity</mat-label>
                                                        <input type="number" matInput
                                                            [formControlName]="'quantity'"
                                                        >
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>VAT</mat-label>
                                                        <mat-select
                                                            [formControlName]="'vat'"
                                                            [panelClass]="'w-full min-w-72 h-auto max-h-72'"
                                                            disableOptionCentering
                                                            (selectionChange)="updateVAT($event, itemControl)">
                                                            <ng-container *ngFor="let vat of vatOptions">
                                                                <mat-option
                                                                    class="h-auto py-4 leading-none"
                                                                    [value]="vat.value"
                                                                    [disabled]="isDispatched()">
                                                                    <div class="font-medium">{{vat?.name}}</div>
                                                                </mat-option>
                                                            </ng-container>
                                                        </mat-select>
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Delivery Date</mat-label>
                                                        <input
                                                            [formControlName]="'requiredDeliveryDate'"
                                                            [matDatepicker]="deliveryDatePicker"
                                                            matInput>
                                                        <mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #deliveryDatePicker></mat-datepicker>
                                                    </mat-form-field>

                                                    <mat-form-field class="sm:col-span-2 w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                                        <mat-label>Priority</mat-label>
                                                        <mat-select [formControlName]="'priority'">
                                                            <ng-container *ngFor="let priority of salesOrderPriorities">
                                                                <mat-option
                                                                    class="h-auto py-4 leading-none"
                                                                    [value]="priority.value"
                                                                    [disabled]="isDispatched()">
                                                                    <div class="font-medium">{{priority?.name}}</div>
                                                                </mat-option>
                                                            </ng-container>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>

                                                <ng-container *ngIf="getBom(itemControl) as bom">
                                                    <div class="w-full px-4 -mt-2 flex flex-col">
                                                        <div class="flex gap-1 items-center">
                                                            <button mat-icon-button matTooltip="Open BOM Info" (click)="openBomInfo(bom, countProductShort(itemControl))">
                                                                <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:info'"></mat-icon>
                                                            </button>
                                                            <span>BOM found: BOM-{{bom.createdDate | date:'yyyy'}}-{{ bom.bomId.toString().padStart(3, '0')}} ({{bom.items.length}} item{{bom.items.length == 1 ? '' : 's'}})</span>
                                                        </div>
                                                        <div *ngIf="countBomShortItems(itemControl) == 0" class="text-green-500 ml-11 -mt-2">All parts in stock</div>
                                                        <div *ngIf="countBomShortItems(itemControl) > 0" class="text-red-500 ml-11 -mt-2">{{countBomShortItems(itemControl)}} part{{countBomShortItems(itemControl) == 1 ? '' : 's'}} short</div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="!getBom(itemControl)">
                                                    <div class="w-full px-4 -mt-2 flex flex-col">No BOM found</div>
                                                </ng-container>
                                                
                                                <div class="p-4 border-t flex gap-4 items-center w-full text-lg">
                                                    <div
                                                        *ngIf="itemControl.controls['productId']?.value"
                                                        class="px-4 py-1 rounded-full text-md"
                                                        [class.text-green-600]="countProductShort(itemControl) == 0"
                                                        [class.text-red-600]="countProductShort(itemControl) > 0"
                                                        [class.bg-green-50]="countProductShort(itemControl) == 0"
                                                        [class.bg-red-50]="countProductShort(itemControl) > 0"
                                                        >
                                                        {{getProductStock(itemControl)}} product{{getProductStock(itemControl) == 1 ? '' : 's'}} in stock
                                                        <ng-container *ngIf="countProductShort(itemControl) > 0">
                                                            <span>({{ countProductShort(itemControl) }} short)</span>
                                                        </ng-container>
                                                       
                                                    </div>
                                                    <div class="ml-auto">Subtotal: {{getPartItemSubtotal(itemControl) | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-template #noItems>
                                <div class="p-8 border-t text-2xl  tracking-tight text-center">
                                    {{ "There are no items yet" }}
                                </div>
                            </ng-template>
                        </div>

                        <div class="col-span-4 flex items-center justify-start">
                            <button
                                *ngIf="!isDispatched()"
                                class="mt-2"
                                color="primary"
                                mat-flat-button
                                type="button"
                                [disabled]="!hasWriteAccess"
                                (click)="isProduct ? addPurchaseOrderProductItem(null) : isSupplier ? addPurchaseOrderPartItem(null) : addPurchaseOrderHireItem(null)">
                                Add Item
                            </button>
                        </div>
                    </div>

                    
                    <div class="border rounded-2xl p-5 flex flex-col gap-6 w-full bg-[#f8f8f8]">
                        <!-- <div class="text-xl">Totals</div> -->

                        <!-- Totals -->
                        <div class="flex flex-col gap-2">
                            <div class="flex flex-row justify-end">
                                <p>Subtotal:</p>
                                <p class="total-value text-right">{{(getGrandSubTotal()) | currency: '£'}}</p>
                            </div>
                            <!-- <div class="flex flex-row justify-end">
                                <p>Discount:</p>
                                <p class="total-value text-right">{{"-" + getTotalForControl('discount') | currency: '£'}}</p>
                            </div> -->
                            <div class="flex flex-row justify-end">
                                <p>VAT:</p>
                                <p class="total-value text-right">{{getTotalVat() | currency: '£'}}</p>
                            </div>

                            <!-- freight amount -->
                            <div class="flex flex-row justify-end items-center">
                                <p>Freight Amount:</p>
                                <p class="total-value text-right">
                                    <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'" style="width: 80px; margin-right: -8px;">
                                        <input
                                            matInput
                                            [value]="purchaseOrder?.freightAmount ?? 0"
                                            [disabled]="!hasWriteAccess"
                                            (blur)="updateFreightAmount($event)">
                                        <span matPrefix class="text-black">£</span>
                                    </mat-form-field>
                                </p>
                            </div>

                            <div class="border-t my-2"></div>

                            <div class="flex flex-row justify-end text-xl">
                                <p>Total:</p>
                                <p class="total-value text-right">{{getGrandTotal() | currency: '£'}}</p>
                            </div>
                        </div>
                    </div>


                    <!-- Actions -->
                    <div class="col-span-4 flex items-center justify-between gap-4 pt-6 border-t">
                        <button
                            class="mr-auto"
                            matStepperPrevious
                            mat-stroked-button
                            type="button">
                            Back
                        </button>

                        <button
                            mat-stroked-button
                            (click)="save(canSaveAsDraft || preventFlaggedPartsProceed())"
                            [disabled]="thirdFormGroup?.invalid || !hasWriteAccess">
                            <span class="ml-2 mr-1">{{ "Save" + (canSaveAsDraft || preventFlaggedPartsProceed() ? " as Draft" : "") }}</span>
                        </button>

                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'"
                            [disabled]="thirdFormGroup?.invalid || preventFlaggedPartsProceed()">
                            Next                
                        </button>
                    </div>
                </form>
            </mat-step>

            <!-- Work Order -->
            <mat-step *ngIf="requiresWorkOrder()" label="Work Order">
                <div class="flex flex-col gap-6">

                    <!-- New Work Orders -->
                    <ng-container *ngIf="getProductItemsRequiringButWithoutWorkOrder()?.length">
                        <div class="text-xl">Work Order{{getProductItemsRequiringButWithoutWorkOrder()?.length > 1 ? 's' : ''}} Required</div>

                        <!-- Warning Box -->
                        <div class="bg-[#fef2f2] border-2 border-[#ef4444] rounded-lg p-5">
                            <div class="flex gap-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="alert-triangle" style="width: 24px; height: 24px; color: #ef4444; flex-shrink: 0;" class="lucide lucide-alert-triangle"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
                                <div>
                                    <h4 style="color: #991b1b; font-weight: 600; margin-bottom: 8px;">Parts Missing - Work Order Required</h4>
                                    <p style="color: #7f1d1d; font-size: 14px; line-height: 1.5;">
                                        One or more products in this order require manufacturing. A Work Order will be automatically created when you complete this Sales Order.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Item Details -->
                        <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                            <div class="text-xl">Items Requiring Manufacturing</div>

                            <form *ngIf="thirdFormGroup" [formGroup]="thirdFormGroup" class="flex flex-col gap-4">
                                <ng-container *ngIf="productItems?.controls" formArrayName="productItems">
                                    <ng-container *ngFor="let itemControl of productItems?.controls; let i = index" [formGroupName]="i">
                                        <div *ngIf="productRequiresWorkOrder(itemControl) && !productHasWorkOrder(itemControl)" class="bg-white border rounded-lg py-3 px-4 flex gap-4 items-center" (click)="openLinkedPo(po.purchaseOrderId)">
                                            <!-- <mat-icon class="text-primary" [svgIcon]="'mat_outline:shopping_cart'"></mat-icon> -->
                                            <div>
                                                <div class="text-primary">{{lookupProduct(itemControl)?.partNumber}}</div>
                                                <div class="text-md">Quantity Missing: {{countProductShort(itemControl)}}</div>
                                                <div *ngIf="countBomShortItems(itemControl) > 0" class="text-md">Parts Missing for Manufacture: {{countBomShortItems(itemControl)}}</div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </form>
                        </div>

                        <!-- Work Order Details -->
                        <form *ngIf="workOrderFormGroup" [formGroup]="workOrderFormGroup" class="flex flex-col gap-6">
                            <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                                <div class="text-xl">Fulfilment Options</div>

                                <!-- Fulfilment Type -->
                                <mat-radio-group [formControlName]="'isWorkOrderFullShipment'" class="grid grid-cols-2 gap-4" color="primary">
                                    <mat-radio-button [value]="false" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="!workOrderFormGroup.controls['isWorkOrderFullShipment'].value" (click)="changeFulfilmentOption({value: false})">
                                        <div class="cursor-pointer">
                                            <div class="flex gap-2 items-center">
                                                <mat-icon class="icon-size-5 text-blue-600" [svgIcon]="'heroicons_outline:truck'"></mat-icon>
                                                <div>Split Shipment</div>
                                            </div>
                                            <div class="text-sm leading-[1.5] ml-1 mt-1">Send available items immediately. Manufacture and ship unavailable items separately when ready.</div>
                                        </div>
                                    </mat-radio-button>
                                    <mat-radio-button [value]="true" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="workOrderFormGroup?.controls['isWorkOrderFullShipment'].value" (click)="changeFulfilmentOption({value: true})">
                                        <div class="cursor-pointer">
                                            <div class="flex gap-2 items-center">
                                                <mat-icon class="icon-size-5 text-yellow-600" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                                                <div>Wait for All Items</div>
                                            </div>
                                            <div class="text-sm leading-[1.5] ml-1 mt-1">Hold all items until everything is manufactured and ready. Ship complete order together.</div>
                                        </div>
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <div *ngIf="isAwaitingCustomerApproval()" class="border rounded-2xl p-5 w-full bg-amber-50 border-amber-300">
                                <div class="flex items-center gap-2 text-amber-700">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                                    <div class="text-lg font-medium">Awaiting Customer Approval</div>
                                </div>
                                <div class="text-sm text-amber-600 mt-1">Scheduling fields are locked until customer approval is received. Approve from the Overview tab.</div>
                            </div>

                            <div class="border rounded-2xl p-5 grid grid-cols-3 gap-6 w-full bg-[#f8f8f8]">
                                <div class="col-span-3 text-xl">Work Order Configuration</div>

                                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Start Date</mat-label>
                                    <input
                                        [formControlName]="'workOrderStartDate'"
                                        [matDatepicker]="woStartDate"
                                        [readonly]="isAwaitingCustomerApproval()"
                                        matInput>
                                    <mat-datepicker-toggle matIconSuffix [for]="woStartDate" [disabled]="isAwaitingCustomerApproval()"></mat-datepicker-toggle>
                                    <mat-datepicker #woStartDate></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Due Date</mat-label>
                                    <input
                                        [formControlName]="'workOrderDueDate'"
                                        [matDatepicker]="woDueDate"
                                        [readonly]="isAwaitingCustomerApproval()"
                                        matInput>
                                    <mat-datepicker-toggle matIconSuffix [for]="woDueDate" [disabled]="isAwaitingCustomerApproval()"></mat-datepicker-toggle>
                                    <mat-datepicker #woDueDate></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Priority</mat-label>
                                    <mat-select [formControlName]="'workOrderPriority'">
                                        <ng-container *ngFor="let priority of salesOrderPriorities">
                                            <mat-option [value]="priority.value">
                                                {{priority?.name}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="col-span-3 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Notes</mat-label>
                                    <textarea
                                        matInput
                                        [formControlName]="'workOrderNotes'"
                                        placeholder="Special instructions or requirements for manufacturing..."
                                        [rows]="2"
                                        cdkTextareaAutosize
                                        [cdkAutosizeMinRows]="2"></textarea>
                                </mat-form-field>
                            </div>
                        </form>
                    </ng-container>

                    <!-- Existing Work Orders -->
                    <ng-container *ngIf="purchaseOrder?.workOrders?.length">
                        <div class="text-xl mt-4">Current Work Orders</div>
                        <ng-container *ngFor="let workOrder of purchaseOrder.workOrders">
                            <div class="border rounded-2xl p-5 grid grid-cols-2 gap-4 w-full bg-[#f8f8f8]">
                                <div class="text-xl col-span-2">Work Order Details - {{workOrder.workOrderRef}}</div>
                                
                                <div class="flex flex-col">
                                    <div class="uppercase text-md">Start Date</div>
                                    <div class="text-lg">{{workOrder.startDate | date:'dd/MM/yyyy'}}</div>
                                </div>
                                <div class="flex flex-col">
                                    <div class="uppercase text-md">Due Date</div>
                                    <div class="text-lg">{{workOrder.dueDate | date:'dd/MM/yyyy'}}</div>
                                </div>
                                <div class="flex flex-col">
                                    <div class="uppercase text-md">Priority</div>
                                    <div class="text-lg">{{getPriorityName(workOrder.priority)}}</div>
                                </div>
                                <div class="flex flex-col">
                                    <div class="uppercase text-md">Status</div>
                                    <div class="text-lg">{{getWorkOrderStatusName(workOrder.status)}}</div>
                                </div>
                                <div class="flex flex-col">
                                    <div class="uppercase text-md">Shipment Type</div>
                                    <div class="text-lg">{{workOrder.isFullShipment ? 'Full Shipment' : 'Partial Shipment'}}</div>
                                </div>
                                <div class="flex flex-col">
                                    <div class="uppercase text-md">Time Required</div>
                                    <div class="text-lg">
                                        <ng-container *ngIf="workOrder.hoursRequired">{{workOrder.hoursRequired}} hour{{workOrder.hoursRequired == 1 ? '' : 's'}}</ng-container>
                                        <ng-container *ngIf="workOrder.hoursRequired && workOrder.daysRequired">&nbsp;(</ng-container>
                                        <ng-container *ngIf="workOrder.daysRequired">{{workOrder.daysRequired}} day{{workOrder.daysRequired == 1 ? '' : 's'}}</ng-container>
                                        <ng-container *ngIf="workOrder.hoursRequired && workOrder.daysRequired">)</ng-container>
                                        <ng-container *ngIf="!workOrder.hoursRequired && !workOrder.daysRequired">Not set</ng-container>
                                    </div>
                                </div>

                                <div class="col-span-2 flex flex-col">
                                    <div class="uppercase text-md">Notes</div>
                                    <div class="">{{workOrder.deliveryNotes}}</div>
                                </div>


                                <div class="col-span-2 bg-white border rounded-lg py-3 px-4 flex gap-4 items-center hover:bg-gray-50 cursor-pointer transition-colors"
                                    (click)="openWorkOrderInfo(workOrder.workOrderId)"
                                    >
                                    <mat-icon class="text-primary" [svgIcon]="'mat_outline:build'"></mat-icon>
                                    <div>
                                        <div class="text-primary">{{workOrder.workOrderRef}}</div>
                                        <!-- <div class="text-md">Subtitle</div> -->
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Actions -->
                    <div class="col-span-4 flex items-center justify-between gap-4 pt-6 border-t">
                        <button
                            class="mr-auto"
                            matStepperPrevious
                            mat-stroked-button
                            type="button">
                            Back
                        </button>

                        <button
                            mat-stroked-button
                            (click)="save(canSaveAsDraft)"
                            [disabled]="!hasWriteAccess">
                            <span class="ml-2 mr-1">{{ "Save" + (canSaveAsDraft ? " as Draft" : "") }}</span>
                        </button>

                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'">
                            Next                
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- Step 4, Preview -->
            <mat-step label="Preview">
                <div class="border rounded-2xl p-5 flex flex-col gap-6 w-full bg-[#f8f8f8] relative">
                    <div class="text-xl">Preview</div>
                    <div class="absolute right-0 mr-4 -mt-1">
                        <button mat-flat-button color="primary" (click)="downloadPdf()">Download</button>
                    </div>

                    <!-- PurchaseOrder Preview -->
                    <div class="flex justify-center">
                        <purchase-order-preview
                            #purchaseOrderPreview2
                            [purchaseOrder]="purchaseOrder"
                            [hireItems]="purchaseOrderHireItems"
                            [partItems]="purchaseOrderPartItems"
                            [productItems]="purchaseOrderProductItems"
                            [contact]="contact"
                            [products]="products"
                            [printSectionId]="'print-section1'">
                        </purchase-order-preview>
                    </div>
                </div>

                <!-- Actions -->
                <div class="flex items-center justify-between gap-4 pt-6 mt-6 border-t">
                    <button
                        class="mr-auto"
                        matStepperPrevious
                        mat-stroked-button
                        type="button">
                        Back
                    </button>

                    <button
                        *ngIf="canSaveAsDraft"
                        mat-stroked-button
                        (click)="save(true)"
                        [disabled]="!hasWriteAccess">
                        <span class="ml-2 mr-1">Save as Draft</span>
                    </button>
                    
                    <button
                        *ngIf="!isClosedForEditing"
                        mat-flat-button
                        [color]="'primary'"
                        (click)="save(false)"
                        [disabled]="!hasWriteAccess">
                        <span class="ml-2 mr-1">Save</span>
                    </button>

                    <button
                        *ngIf="isClosedForEditing && isSupplier && purchaseOrder?.status == PurchaseOrderStatus.Approved"
                        mat-flat-button
                        [color]="'primary'"
                        (click)="sendToSupplier()"
                        [disabled]="!hasWriteAccess">
                        <mat-icon class="icon-size-4 mr-1" svgIcon="heroicons_outline:paper-airplane"></mat-icon>
                        <span class="ml-2 mr-1">Send to Supplier</span>
                    </button>

                    <button
                        *ngIf="isClosedForEditing"
                        mat-flat-button
                        [color]="'primary'"
                        (click)="close()">
                        <span class="ml-2 mr-1">Close</span>
                    </button>

                    <button
                        *ngIf="purchaseOrder?.status == PurchaseOrderStatus.Created || purchaseOrder?.status == PurchaseOrderStatus.Rejected"
                        mat-flat-button
                        [color]="'primary'"
                        (click)="submitForApproval()"
                        [disabled]="!hasWriteAccess">
                        <span class="ml-2 mr-1">Submit for Approval</span>
                    </button>
                </div>
            </mat-step>

        </mat-horizontal-stepper>
    </div>


    <div id="print-preview" class="w-full" style="display: none; margin-top: 2000px;">
        <purchase-order-preview
            #purchaseOrderPreview
            [purchaseOrder]="purchaseOrder"
            [hireItems]="purchaseOrderHireItems"
            [partItems]="purchaseOrderPartItems"
            [productItems]="purchaseOrderProductItems"
            [contact]="contact"
            [products]="products"
            [printSectionId]="'print-section2'">
        </purchase-order-preview>
    </div>
</div>
